<template>
    <div>
        <div v-if="!user">Loading...</div>
        <div v-else>
            <form-wizard
                title="Update Account"
                subtitle
                color="#81b231"
                :finishButtonText="processing ? 'Processing...' : 'Complete'"
                @on-complete="thankYou"
            >
                <tab-content
                    title="Personal Details"
                    icon="fa fa-check"
                    :before-change="setPersonal"
                >
                    <div class="row">
                        <div class="col-md-12 col-lg-12 mt-10">
                            <form class="js-validation-signin">
                                <div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="firstname"
                                                >FIRSTNAME</label
                                            >
                                            <input
                                                id="firstname"
                                                type="text"
                                                class="form-control"
                                                required
                                                name="firstname"
                                                placeholder="Enter firstname"
                                                autocomplete="phone"
                                                v-model="user.first_name"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="lastname"
                                                >LASTNAME</label
                                            >
                                            <input
                                                id="lastname"
                                                name="lastname"
                                                type="text"
                                                class="form-control"
                                                placeholder="Enter lastname"
                                                required
                                                autocomplete="phone"
                                                v-model="user.last_name"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="phonw">PHONE</label>
                                            <input
                                                id="phone"
                                                type="text"
                                                class="form-control"
                                                required
                                                placeholder="Enter phone number"
                                                autocomplete="phone"
                                                v-model="user.phone"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="email">EMAIL</label>
                                            <input
                                                id="email"
                                                type="text"
                                                class="form-control"
                                                required
                                                placeholder="Enter email address"
                                                autocomplete="email"
                                                v-model="user.email"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="gender">GENDER</label>
                                            <select
                                                v-model="user.gender"
                                                name="gender"
                                                id="gender"
                                                class="form-control"
                                            >
                                                <option
                                                    selected
                                                    disabled
                                                    value=""
                                                    >-- Choose Gender --</option
                                                >
                                                <option value="Male"
                                                    >Male</option
                                                >
                                                <option value="Female"
                                                    >Female</option
                                                >
                                                <option value="Others"
                                                    >Others</option
                                                >
                                            </select>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="login-password"
                                                >DATE OF BIRTH</label
                                            >
                                            <input
                                                v-model="user.dob"
                                                type="date"
                                                class="js-datepicker form-control"
                                                id="example-datepicker3"
                                                name="example-datepicker3"
                                                data-week-start="1"
                                                data-autoclose="true"
                                                data-today-highlight="true"
                                                data-date-format="dd-mm-yyyy"
                                                placeholder="dd-mm-yyyy"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="country">COUNTRY</label>
                                            <country-select
                                                class="form-control"
                                                v-model="user.country"
                                                :country="user.country"
                                                topCountry="US"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="login-password"
                                                >STATE</label
                                            >
                                            <region-select
                                                class="form-control"
                                                v-model="user.state"
                                                :country="user.country"
                                                :region="user.state"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="firstname"
                                                >ADDRESS</label
                                            >
                                            <input
                                                id="address"
                                                d
                                                type="text"
                                                class="form-control"
                                                required
                                                placeholder="Enter address"
                                                v-model="user.address"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="lastname">CITY</label>
                                            <input
                                                id="city"
                                                type="text"
                                                class="form-control"
                                                placeholder="Enter city"
                                                required
                                                v-model="user.city"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </tab-content>
                <tab-content title="Account" icon="fa fa-check">
                    <div class="col-lg-12 mt-30">
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label for="gender"
                                    >Preferred Account Type</label
                                >
                                <select
                                    v-model="user.account_type"
                                    name="account_type"
                                    id="account_type"
                                    class="form-control"
                                >
                                    <option selected disabled value=""
                                        >-- Choose Account Type --</option
                                    >
                                    <option value="SAVINGS"
                                        >Savings Account</option
                                    >
                                    <option value="JOIN">Joint Account</option>
                                    <option value="CHECKING"
                                        >Checking Account</option
                                    >
                                    <option value="OFFSHORE"
                                        >OffShore Account</option
                                    >
                                </select>
                            </div>
                            <div class="col-lg-6">
                                <label for="login-password"
                                    >Preferred Account Currency</label
                                >
                                <select
                                    class="form-control"
                                    required
                                    v-model="user.currency"
                                >
                                    <option value="1">Euro (€)</option>
                                    <option value="2">Pounds (£)</option>
                                    <option value="3"
                                        >Australian dollar ($)</option
                                    >
                                    <option value="4"
                                        >New Zealand dollar ($)</option
                                    >
                                    <option value="5"
                                        >Canadian dollar ($)</option
                                    >
                                    <option value="6">Japanese yen (¥)</option>
                                    <option value="7">Swiss franc (₣)</option>
                                    <option value="8"
                                        >United States Dollar ($)</option
                                    >
                                </select>
                            </div>
                        </div>
                    </div>
                </tab-content>
                <tab-content
                    title="Uploads"
                    icon="fa fa-check"
                    :before-change="updateUser"
                >
                    <div class="col-lg-10 mt-30">
                        <img
                            class="img-avatar img-avatar96"
                            :src="
                                image_url ? image_url : `/avatar/${user.avatar}`
                            "
                        />
                        <form enctype="multipart/form-data">
                            <div class="form-group">
                                <label class="text-muted">
                                    Upload Avatar
                                </label>
                                <small class="text-danger">required</small>

                                <div class="custom-file">
                                    <input
                                        type="file"
                                        ref="file"
                                        class="custom-file-input"
                                        id="example-file-input-custom"
                                        name="example-file-input-custom"
                                        data-toggle="custom-file-input"
                                        @change="onAvatarChanged"
                                        accept=".jpeg, .jpg, .png"
                                        required
                                    />
                                    <label
                                        class="custom-file-label"
                                        for="example-file-input-custom"
                                        >Choose Avatar</label
                                    >
                                </div>
                            </div>
                        </form>
                    </div>
                </tab-content>

                <tab-content title="Completed" icon="fa fa-check">
                    <div class="col-lg-12 mt-30">
                        <div class="py-30 text-center">
                            <h3 class="h3 font-w700 base-color mb-10">
                                Account updated successfully!
                            </h3>
                        </div>
                    </div>
                </tab-content>
            </form-wizard>
            <!-- identity modal -->
            <div class="modal fade" id="modal-identity" tabindex="-1">
                <div class="modal-dialog modal-dialog-sm modal-dialog-centered">
                    <div class="modal-content">
                        <a
                            href="#"
                            class="modal-close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <em class="ti ti-close"></em>
                        </a>
                        <div class="popup-body">
                            <div class="container">
                                <div class="modal-body mb-0 p-0 mt-3">
                                    <img
                                        style="width: 100% !important"
                                        :src="'/identity/' + user.identity"
                                        alt="..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- .modal-content -->
                </div>
                <!-- .modal-dialog -->
            </div>
            <!-- identity modal end -->
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    props: {
        user: Object,
        require: true
    },
    data() {
        return {
            processing: false,
            image_url: "",
            avatar: "",
            file: "",
            date: "",
            amount: 0,
            currency: 8
        };
    },
    methods: {
        onAvatarChanged() {
            var uploadedFile = this.$refs.file.files[0];
            this.avatar = uploadedFile;
            this.image_url = URL.createObjectURL(uploadedFile);
            return;
        },
        onFileChanged() {
            var uploadedFile = this.$refs.file1.files[0];
            this.file = uploadedFile;
            return;
        },
        setPersonal() {
            let user = this.user;
            if (
                user.first_name &&
                user.last_name &&
                user.phone &&
                user.country &&
                user.city &&
                user.address &&
                user.state &&
                user.dob &&
                user.gender &&
                user.email
            ) {
                return true;
            } else {
                toast.fire({
                    type: "error",
                    title: "Ensure all fields are filled"
                });
                return false;
            }
        },
        async updateUser() {
            try {
                this.processing = true;

                var formData = new FormData();
                formData.append("avatar", this.avatar);
                formData.append("first_name", this.user.first_name);
                formData.append("last_name", this.user.last_name);
                formData.append("email", this.user.email);
                formData.append("dob", this.user.dob);
                formData.append("state", this.user.state);
                formData.append("country", this.user.country);
                formData.append("gender", this.user.gender);
                formData.append("phone", this.user.phone);
                formData.append("currency", this.user.currency);
                formData.append("account_type", this.user.account_type);
                formData.append("city", this.city);
                formData.append("address", this.address);

                await UsersRepository.userUpdate(this.user.id, formData);
                toast.fire({
                    type: "success",
                    title: "Update successful"
                });

                this.processing = false;
                this.refresh();
                return true;
            } catch (error) {
                this.processing = false;
                if (error.response.status == 422) {
                    toast.fire({
                        type: "error",
                        title: error.response.data.errors.email[0]
                    });
                } else {
                    toast.fire({
                        type: "error",
                        title: "Something went wrong"
                    });
                }
            }
        },
        refresh() {
            this.$emit("refresh");
        },
        thankYou() {
            window.location = "/management/users";
        }
    }
};
</script>

<style scoped></style>
